<template>
  <div class="login-wrapper">
    <div class="login-container">
      <!-- Left Side - Image -->
      <div class="login-image-section">
        <div class="image-overlay">
          <img
            src="../../assets/loginimage.png"
            alt="Karnataka"
            class="login-image"
          />
          <div class="image-text">
            <h1 class="brand-title">Welcome to</h1>
            <h2 class="brand-title">Jeevasarthakathe-SOTTO Karnataka</h2>
            <p>Karnataka State Organ and Tissue Transplant Organisation</p>
          </div>
        </div>
      </div>

      <!-- Right Side - Login Form -->
      <div class="login-form-section">
        <div class="login-form-container">
          <div class="login-header">
            <h2>Sign In</h2>
            <p>Please enter your credentials to continue</p>
          </div>

          <form-wrapper @submit="submit">
            <div class="d-none">
              <input type="password" tabindex="-1" />
            </div>
            <div class="form-group-custom">
              <InputField
                type="email"
                rules="required|email"
                v-model="form.email_id"
                label="Email Address"
                @focus="onFocus"
                autocomplete="off"
                id="login_email"
                invalid="Enter the Email Address"
              >
              </InputField>
            </div>
            <div class="form-group-custom">
              <password-input
                label="Password"
                rules="required"
                type="password"
                v-model="form.password"
                invalid="Enter the Password"
                @focus="onFocus"
                id="login_password"
                autocomplete="off"
              >
              </password-input>
            </div>
            <div class="forgot-password-link">
              <a @click="$router.push('/forgot-password')">
                Forgot Password?
              </a>
            </div>
            <!-- VAPT Fix W16: CAPTCHA always visible on login page (mandatory) -->
            <vue-recaptcha
              class="mt-2"
              sitekey="6Ldd1ckaAAAAAGREbWaQDMwQfSYyEC2jHvteMmBu"
              :loadRecaptchaScript="true"
              @verify="onCaptchaVerify"
              @expired="onCaptchaExpired"
            ></vue-recaptcha>
            <p v-if="failedAttempts > 0" class="attempt-warning">
              <span v-if="failedAttempts < 5">
                {{ failedAttempts }} failed sign-in attempt{{ failedAttempts > 1 ? 's' : '' }}.
              </span>
              <span v-else class="text-danger">
                Too many failed attempts. Try again in a few minutes.
              </span>
            </p>
            <b-button
              block
              class="login-btn mt-3"
              variant="primary"
              type="submit"
              :disabled="isLocked || !captchaToken"
            >
              Sign In
            </b-button>
          </form-wrapper>

          <div class="divider">
            <span>OR</span>
          </div>

          <div class="other-actions">
            <!-- <b-button
              block
              class="action-btn"
              variant="outline-success"
              @click="$router.push('/commong-waiting-list')"
            >
              View Common Waiting List
            </b-button> -->
            <b-button
              block
              class="action-btn mt-3"
              variant="outline-primary"
              @click="$router.push('/registration')"
            >
              Create New Account
            </b-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { USER_TYPES } from "../../assets/constants/hospital.contants";
import commonHelper from "../../assets/helper/common.helper";
import { encrypt } from "../../assets/js/common";
import userService from "../../assets/services/user.service";
import PasswordInput from "../../components/form/PasswordInput.vue";
import VueRecaptcha from "vue-recaptcha";
export default {
  components: { PasswordInput, VueRecaptcha },
  data() {
    return {
      form: {
        email_id: "",
        password: "",
      },
      token: "",
      failedAttempts: 0,
      captchaToken: "",
      isLocked: false,
    };
  },
  computed: {
    types() {
      return USER_TYPES;
    },
  },
  methods: {
    onFocus(event) {
      event.target.scrollIntoView();
      setTimeout(() => {
        event.target.scrollIntoView();
      }, 1000);
    },
    onCaptchaVerify(val) {
      this.captchaToken = val;
    },
    onCaptchaExpired() {
      this.captchaToken = "";
    },
    async submit() {
      const vm = this;
      // VAPT Fix W16: soft lockout at 5 failed attempts
      if (vm.isLocked) {
        vm.$alert.show("Too many failed attempts. Try again later.");
        return;
      }
      // VAPT Fix W16: CAPTCHA is mandatory on every login attempt
      if (!vm.captchaToken) {
        vm.$alert.show("Please complete the CAPTCHA");
        return;
      }
      let doc = {};
      Object.keys(vm.form).forEach((key) => {
        doc[key] = vm.form[key];
      });
      doc.dml_indicator = "L";
      doc.password = encrypt(doc.password);
      doc.email_id = encrypt(doc.email_id);
      if (vm.captchaToken) doc.verfication_code = vm.captchaToken;
      vm.$loader.show();
      try {
        let { data } = await userService.login(doc);
        vm.$loader.hide();
        let { status, msg } = data;
        if (!status) {
          vm.$loader.hide();
          vm.failedAttempts += 1;
          vm.captchaToken = "";
          if (vm.failedAttempts >= 5) {
            vm.isLocked = true;
            setTimeout(() => {
              vm.isLocked = false;
              vm.failedAttempts = 0;
            }, 5 * 60 * 1000);
          }
          if (msg == "No Record Founds") {
            msg = "The entered Email ID and Password is Invalid";
          } else if (Array.isArray(msg) && msg[0] && msg[0].StrMsg) {
            msg = msg[0].StrMsg;
          }
          vm.$alert.show(msg);
          return;
        }
        vm.failedAttempts = 0;
        commonHelper.setAuth(vm, data);
        location.href = "/";
        vm.$loader.hide();
      } catch (error) {
        vm.$loader.hide();
        vm.failedAttempts += 1;
        vm.captchaToken = "";
        vm.$alert.show(error.message);
      }
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  bottom: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 15px;
  overflow: hidden;
}

.login-container {
  display: flex;
  width: 100%;
  max-width: 950px;
  max-height: 100%;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0 20px 40px -12px rgba(0, 0, 0, 0.15);
  overflow: hidden;
}

/* Left Side - Image Section */
.login-image-section {
  flex: 1;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  padding: 30px;
}

.image-overlay {
  text-align: center;
  color: white;
}

.login-image {
  max-width: 100%;
  max-height: 280px;
  object-fit: contain;
  margin-bottom: 20px;
  filter: drop-shadow(0 10px 20px rgba(0, 0, 0, 0.3));
}

.image-text h1 {
  font-size: 1.2rem;
  font-weight: 300;
  margin-bottom: 5px;
  opacity: 0.9;
}

.image-text h2 {
  font-size: 1.6rem;
  font-weight: 700;
  margin-bottom: 10px;
}

.brand-title {
  color: #FFD700;
}

.image-text p {
  font-size: 0.85rem;
  opacity: 0.8;
  max-width: 280px;
  margin: 0 auto;
  line-height: 1.4;
}

/* Right Side - Form Section */
.login-form-section {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 35px 40px;
  background: #ffffff;
}

.login-form-container {
  width: 100%;
  max-width: 340px;
}

.login-header {
  text-align: center;
  margin-bottom: 25px;
}

.login-header h2 {
  font-size: 1.75rem;
  font-weight: 700;
  color: #1e3c72;
  margin-bottom: 8px;
}

.login-header p {
  color: #6c757d;
  font-size: 0.9rem;
}

.form-group-custom {
  margin-bottom: 5px;
}

.forgot-password-link {
  text-align: right;
  margin-top: -5px;
  margin-bottom: 10px;
}

.forgot-password-link a {
  color: #2a5298;
  font-size: 0.9rem;
  cursor: pointer;
  text-decoration: none;
  transition: color 0.3s ease;
}

.forgot-password-link a:hover {
  color: #1e3c72;
  text-decoration: underline;
}

.attempt-warning {
  font-size: 0.8rem;
  color: #856404;
  background: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 6px;
  padding: 6px 10px;
  margin-top: 8px;
  margin-bottom: 0;
}

.attempt-warning .text-danger {
  color: #721c24 !important;
}

.login-btn {
  padding: 10px 18px;
  font-size: 0.95rem;
  font-weight: 600;
  border-radius: 8px;
  background: linear-gradient(135deg, #1e3c72 0%, #2a5298 100%);
  border: none;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.login-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 5px 20px rgba(30, 60, 114, 0.4);
}

.divider {
  display: flex;
  align-items: center;
  margin: 18px 0;
}

.divider::before,
.divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e0e0e0;
}

.divider span {
  padding: 0 12px;
  color: #9e9e9e;
  font-size: 0.8rem;
  font-weight: 500;
}

.action-btn {
  padding: 8px 16px;
  font-size: 0.9rem;
  font-weight: 500;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.action-btn:hover {
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 900px) {
  .login-container {
    flex-direction: column;
    max-width: 420px;
    overflow-y: auto;
  }

  .login-image-section {
    padding: 15px;
    min-height: auto;
    flex: none;
  }

  .login-image {
    max-height: 100px;
    margin-bottom: 10px;
  }

  .image-text h1 {
    font-size: 0.9rem;
    margin-bottom: 2px;
  }

  .image-text h2 {
    font-size: 1.1rem;
    margin-bottom: 5px;
  }

  .image-text p {
    font-size: 0.7rem;
  }

  .login-form-section {
    padding: 15px 20px;
    flex: none;
  }

  .login-header {
    margin-bottom: 12px;
  }

  .login-header h2 {
    font-size: 1.3rem;
  }

  .login-header p {
    font-size: 0.8rem;
  }
}

@media (max-width: 480px) {
  .login-wrapper {
    padding: 8px;
  }

  .login-form-section {
    padding: 12px 15px;
  }

  .login-header h2 {
    font-size: 1.2rem;
  }

  .login-image {
    max-height: 80px;
  }

  .divider {
    margin: 10px 0;
  }

  .action-btn {
    padding: 6px 10px;
    font-size: 0.8rem;
  }

  .login-btn {
    padding: 8px 14px;
    font-size: 0.9rem;
  }
}
</style>
